import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';

import { phoneNumberFormatter } from '../../helpers/General/PhoneNunberFormatter'
import { owner } from '../../core/controllers/Owner';
import { modal } from '../../core/utilities/modal'
import UnitedStatesSelect from '../../helpers/General/UnitedStatesSelect.jsx';
import FeesSelect from '../../helpers/Fees/FeesSelect';

export default class UserEdit extends React.Component {
    constructor(props) {
        super(props);
        var self = this;

        this.state = {
            ownerId : props.ownerId,
            newOwner: props.newOwner ? true : false,
            sortID: null,
            owner: {
                name: '',
                company_name: '',
                phone: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                email: '',
                fee_id: 0
            },
            feeDetails: null,
            emailOwner: true,
            active: false,
            wasInvited: false
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.state.newOwner) {
            owner.getOwner(this.state.ownerId,function(response) {
                self.setState({
                    owner: response.data.owner,
                    feeDetails: response.data.fee,
                    active: response.data.active,
                    wasInvited: response.data.was_invited
                });
            });
        }

        jQuery(".email-checkbox").change(function(e){
            const value = jQuery(e.target).prop('checked');
            self.setState({ emailOwner: value })
        });
    }

    handleNameChange(e){
        this.setState({
            owner: update(this.state.owner, {
                name: {$set: e.target.value}
            })
        });
    }

    handleCompanyChange(e){
        this.setState({
            owner: update(this.state.owner, {
                company_name: {$set: e.target.value}
            })
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            owner: update(this.state.owner, {
                phone: {$set: phoneNumber}
            })
        });
    }

    updateOwnerAccount(e) {
        if(!this.validateData()){
            return;
        }

        var self = this;
        owner.updateUserAccount(this.state.owner, function(response) {
            modal.resetBackDrop();
            modal.showInfo("Owner account has been updated.", "success", "top", "center");
            owner.getOwner(self.state.ownerId,function(response) {
                self.setState({
                    owner: response.data.owner,
                    feeDetails: response.data.fee
                });
            });
        });
    }

    deleteOwnerAccount(e) {
        owner.deleteOwnerAccount(this.state.ownerId, function(response) {
            modal.resetBackDrop();
            modal.showSuccess('Owner deleted!', 'Owner account has been removed.');
            jQuery(".move-on").on('click',function() {
				browserHistory.goBack();
            });
        });
    }

    saveOwner(e) {
        if(!this.validateData()){
            return;
        }
        var request          = this.state.owner;
        request.email_tenant = this.state.emailOwner;
        owner.saveOwnerAccount(request, function(response) {
            modal.resetBackDrop();
            modal.showSuccess('Owner Added!', 'Owner account has been added.');
            jQuery(".move-on").on('click',function() {
				browserHistory.goBack();
            });
        });
    }

    handleAddressChange(e) {
        this.setState({
            owner: update(this.state.owner, {
                address: {$set: e.target.value}
            })
        });
    }

    handleCityChange(e) {
        this.setState({
            owner: update(this.state.owner, {
                city: {$set: e.target.value}
            })
        });
    }

    handleStateChange(e) {
        this.setState({
            owner: update(this.state.owner, {
                state: {$set: e.target.value}
            })
        });
    }

    handleZipcodeChange(e) {
        this.setState({
            owner: update(this.state.owner, {
                zip: {$set: e.target.value}
            })
        });
    }

    handleEmailChange(e) {
        this.setState({
            owner: update(this.state.owner, {
                email: {$set: e.target.value}
            })
        });
    }

    handleFeeChange(e) {
        this.setState({
            owner: update(this.state.owner, {
                fee_id: {$set: e.target.value
                }}
            )
        });
    }

    validateData() {
        const enteredData = this.state.owner;
        const name = enteredData.name;
        const phone = enteredData.phone;
        const address = enteredData.address;
        const zipcode = enteredData.zip;
        const city = enteredData.city;
        const state = enteredData.state;
        const email = enteredData.email;

        const newOwner = this.props.newOwner;
        const emailOwner = this.state.emailOwner;

        if(name == null || name.length == 0) {
            modal.showInfo("Enter the owners name", "warning", "top", "center");
            return false;
        } else if(email == null || email.length == 0) {
            modal.showInfo("Enter the primary email", "warning", "top", "center");
            return false;
        } else if(phone == null || phone.length == 0) {
            modal.showInfo("Enter the primary phone number", "warning", "top", "center");
            return false;
        } else if(address == null || address.length == 0) {
            modal.showInfo("Enter the primary address", "warning", "top", "center");
            return false;
        } else if(zipcode == null || zipcode.length == 0) {
            modal.showInfo("Enter the zipcode", "warning", "top", "center");
            return false;
        } else if(city == null || city.length == 0) {
            modal.showInfo("Enter the city", "warning", "top", "center");
            return false;
        } else if(state == null || state.length == 0) {
            modal.showInfo("Enter the state", "warning", "top", "center");
            return false;
        }

        if (emailOwner) {
            if (newOwner) {
                if (email === undefined || email.length == 0) {
                    modal.showInfo("You need to enter the owner's email.", "warning", "top", "center");
                    return false;
                }
            }
        }

        // validate email
        const lastAtPos = email.lastIndexOf('@');
        const lastDotPos = email.lastIndexOf('.');
        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
            modal.showInfo("Email is invalid.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    activationEmail() {
        owner.sendActivation(this.state.ownerId, function(response) {
            modal.showInfo("Owner has been invited to join Leasey.", "success", "top", "center");
        });
    }

    render(){
        var self = this;
        const newOwner = this.props.newOwner;

        const company = this.state.owner.company_name;
        const phone = this.state.owner.phone;
        const address = this.state.owner.address;
        const city = this.state.owner.city;
        const state = this.state.owner.state;
        const zipcode = this.state.owner.zip;
        const email = this.state.owner.email;
        const name = this.state.owner.name;
        const fee = this.state.owner.fee_id;
        const feeDetails =  this.state.feeDetails;
        const emailOwner = this.state.emailOwner;
        const active = this.state.active;
        const wasInvited = this.state.wasInvited;
        var buttonText = 'Update Owner';
        var resetText = '';
        if(newOwner) {
            buttonText = 'Add Owner';
        } else {
            resetText = 'Reset'
        }

        return (
        <div>
        <div class="row blue-bottom-margin">
            <div class="row">
                <div class="sub-page-header-row col-md-11">
                    <div class="row">
                        {newOwner ? (
                        <span class="sub-page-header-title">Add an Owner</span>
                        ) : (
                        <span class="sub-page-header-title">{name}</span>
                        )}
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Owner Information</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <form>
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input type="text" class="form-control tenant-info" name="name" placeholder="Name" id="name" value={name} onChange={this.handleNameChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-5 col-md-offset-1">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="text" class="form-control tenant-info" disabled={wasInvited} name="email" placeholder="Email" id="email" value={email} onChange={this.handleEmailChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Company</label>
                                        <input type="text" class="form-control tenant-info" value={company} name="firstname" placeholder="Firstname" id="firstname" onChange={this.handleCompanyChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-5 col-md-offset-1">
                                    <div class="form-group">
                                        <label>Phone</label>
                                        <input type="text" class="form-control tenant-info" name="phone" placeholder="Phone Number" id="phone" value={phone} onChange={this.handlePhoneChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label for="address">Address</label>
                                        <input type="text" class="form-control" value={address} onChange={this.handleAddressChange.bind(this)} placeholder="10000 Marshall Dr." />
                                    </div>
                                </div>
                                <div class="col-md-5 col-md-offset-1">
                                    <div class="form-group">
                                        <label for="address">Zipcode</label>
                                        <input type="text" class="form-control" value={zipcode} onChange={this.handleZipcodeChange.bind(this)} placeholder="62472" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label for="city">City</label>
                                        <input type="text" class="form-control" value={city} name="city" onChange={this.handleCityChange.bind(this)} placeholder="Lenexa" />
                                    </div>
                                </div>
                                <div class="col-md-5 col-md-offset-1">
                                    <div class="form-group">
                                        <UnitedStatesSelect columnSize={0} sortID={state} title="State" onChange={this.handleStateChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                            {newOwner && (
                            <div class="row">
                                <div class="col-md-12" >
                                    <div class="form-group">
                                        <p class="email-checkbox-text"><input type="checkbox" class="email-checkbox" defaultChecked={emailOwner} data-toggle="toggle"/> <b>Send owner email invitation to portal</b></p>
                                    </div>
                                </div>
                            </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
            {!newOwner && (
            <div class="col-md-4 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="header col-md-12 col-sm-12 col-xs-12">
                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-hand-action"></i></span> Action Center</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12 col-sm-12 col-xs-12 action-center-item-title">
                                <div class="col-md-6 col-sm-5 col-xs-12">
                                    <label>Portal</label>
                                    {active == true ? (
                                    <h5 class="title action-center-item-text">Activated</h5>
                                    ) : (
                                    <h5 class="title action-center-item-text">Not Activated</h5>
                                    )}
                                </div>
                                <div class="col-md-6 col-sm-7 col-xs-12 action-center-button">
                                    <button type="button" data-loading-text="Loading..." disabled={active} class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.activationEmail.bind(this)}>
                                        Invite Owner
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
            <div class="col-md-4 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="header">
                                <h4 class="title"><i class="pe-7s-cash"></i> Fees</h4>
                                <p class="category">Any fees added will be automatically included at the end of each month for owner payout.</p>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="content">
                                        { feeDetails != null && (
                                            <span>
                                            <p>Amount: <b>${feeDetails.fee_amount / 100}</b></p>
                                            <p>Percentage: <b>{feeDetails.fee_percentage}%</b></p>
                                            </span>
                                        )}
                                        <FeesSelect columnSize={0} sortID={fee} title="" onChange={this.handleFeeChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row blue-bottom">
            <div class="blue-bottom-center-align">
                { newOwner === false ? (
                    <div>
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteOwnerAccount.bind(this)}>
                            Delete Owner
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.updateOwnerAccount.bind(this)}>
                            {buttonText}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div class="col-md-12">
                        <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.saveOwner.bind(this)}>
                        {buttonText}
                        </button>
                    </div>
                )}
                <div class="clearfix"></div>
            </div>
        </div>
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Owner/OwnerEdit.jsx